<template>
  <div>
    <div class="header" v-if="!mobileType">
      <div class="header-sub logo" v-show="!mobileType" >
        <img class="logo-item" src="/img/img/umeyelogo1.png">
      </div>
      <div class="header-sub right-sub">
        <div class="header-item">简体中文</div>
        <div class="header-item">QQ</div>
        <div class="header-item">微信</div>
        <div class="header-item">意见反馈</div>
        <div class="header-item">APP下载</div>
      </div>
      <div :style="{'clear':'both','height':'40px'}"></div>
      <div @mouseleave="out">
        <div class="menu">
          <div class="left-icon"></div>
          <div class="menu-nav">
            <div @mouseover="() => hold(-1)" class="menu-item">
              <a href="/">首页</a>
            </div>
            <div :key="index" v-for="(item, index) in main_menu" class="menu-item" @mouseover="() => hold(index)">
              <div>
                <a :href="item.href">{{item.name}}</a>
              </div>
              <i class="open-menu el-icon-arrow-down"></i>
            </div>
          </div>
          <div class="right-icon">
            <div @click="goLogin" class="go-login">登录平台</div>
          </div>
        </div>
        <!-- <div class="menu-list">
          <div :style="{'line-height':'0'}" class="left-icon">沟通您的视界</div>
          <div class="simple-menu-item">
            <div>首页</div>
          </div>
          <div class="simple-menu-item">
            <div>云平台</div>
            <div v-if="selected === 0" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="value-item">
                    <a href="/cloud#info">平台简介</a>
                  </p>
                  <p class="value-item">
                    <a href="/cloud#advantage">平台优势</a>
                  </p>
                  <p class="value-item">
                    <a href="/cloud#cmposition">平台组成</a>
                  </p>
                  <p class="value-item">
                    <a href="/cloud#field">应用行业</a>
                  </p>
                  <p class="value-item">
                    <a href="/cloud#case">合作代表</a>
                  </p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/27114811uuyk.jpg">
                  <p class="info-item">
                    科缔云整合了流媒体与P2P解决方案，可100%实现穿透
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="simple-menu-item">
            <div>硬件接入</div>
            <div v-if="selected === 1" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="title-item">产品引用解决方案</p>
                  <p class="value-item">方案简介</p>
                  <p class="value-item">成功案例</p>
                  <p class="title-item">监控系统解决方案</p>
                  <p class="value-item">方案简介</p>
                  <p class="value-item">成功案例</p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/11101827wr5j.jpg">
                  <p class="info-item">
                    我们针对不同行业，提供当下比较主流的安防解决方案，如果您需要定制个性化的行业解决方案，请拨打4000-500-876进行咨询！
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="simple-menu-item">
            <div>APP开发</div>
            <div v-if="selected === 2" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="title-item">APP简介</p>
                  <p class="title-item">功能OEM</p>
                  <p class="value-item">基于KDView</p>
                  <p class="title-item">量身定制</p>
                  <p class="value-item">成功案例</p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/271148551r3u.jpg">
                  <p class="info-item">
                    提供IOS(苹果)、Android、PC、WP等多种系统平台功能开发定制。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="simple-menu-item">
            <div>服务部署</div>
            <div v-if="selected === 3" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="title-item">技术支持</p>
                  <p class="title-item">web在线观看</p>
                  <p class="title-item">下载</p>
                  <p class="value-item">客户端下载</p>
                  <p class="value-item">SDK开发</p>
                  <p class="value-item">其它下载</p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/11094152znhg.jpg">
                  <p class="info-item">
                    我们有完善的售后服务体系，拥有一支专门提供售后服务的团队，可以及时高效地为您提供各种服务支持！
                  </p>
                  <p class="info-item">
                    全国免费服务热线：4000-500-876
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="simple-menu-item">
            <div>方案&案例</div>
            <div v-if="selected === 4" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="title-item">公司介绍</p>
                  <p class="title-item">团队简介</p>
                  <p class="title-item">联系我们</p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/11095920bemd.jpg">
                  <p class="info-item">
                    我们有共同的目标，我们有超强的团队凝聚力，我们相信会更好，也欢迎您加入我们这个大家庭！
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="simple-menu-item">
            <div>关于我们</div> 
            <div v-if="selected === 5" class="menu-list-box">
              <div class="menu-list-box-real" :style="{'position': 'relative','left': '-180px'}">
                <div class="menu-list-box-item left-item">
                  <p class="value-item">
                    <a href="/introduce#company">公司介绍</a>
                  </p>
                  <p class="value-item">
                    <a href="/introduce#team">团队简介</a>
                  </p>
                  <p class="value-item">
                    <a href="/introduce#contact">联系我们</a>
                  </p>
                </div>
                <div class="menu-list-box-item right-item">
                  <img src="/img/img/11095920bemd.jpg">
                  <p class="info-item">
                    我们有共同的目标，我们有超强的团队凝聚力，我们相信会更好，也欢迎您加入我们这个大家庭！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="mobileType" :style="{'width':'100vw','height':'53px'}"></div>
    <div v-if="mobileType" class="mb-header">
      <!-- <div class="header-sub logo">
        <img class="logo-item" src="/img/img/umeyelogo1.png">
      </div> -->
      <div class="mb-menu-icon " :class="{'openmenu': openMenu}">
        <i class="el-icon-menu" @click="toggleMobileMenu"></i>
      </div>
      <div :class="{'hide': !openMenu}"  class="mb-menu">
        <div class="mb-top-box"></div>
        <a class="mb-menu-item" href="/">首页</a>
        <div 
          :key="index" v-for="(item, index) in main_menu"
          :class="{'open': showMenu.includes(index)}" 
          class="mb-menu-item" 
          @click="toggleMobileMenuList(index, showMenu.includes(index))"
        >
          <a :href="item.href">{{item.name}}</a>
          <!-- <i class="mb-menu-open-icon el-icon-arrow-right"></i> -->
          <!-- <div @click.stop>
            <div v-if="index === 0" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one">
                <a href="/cloud#info">平台简介</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/cloud#advantage">平台优势</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/cloud#cmposition">平台组成</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/cloud#field">应用行业</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/cloud#case">合作代表</a>
              </div>
            </div>
            <div v-if="index === 1" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one" @click="toggleMobileSubMenuList('plan_1')" :class="{'open': subMenu.includes('plan_1')}">
                产品引用解决方案
                <i class="mb-menu-open-icon el-icon-arrow-right"></i>
              </div>
              <div class="mb-menu-sub-item-two" :class="{'open': subMenu.includes('plan_1')}">
                <div>方案简介</div>
                <div>成功案例</div>
              </div>
              <div class="mb-menu-sub-item-one" @click="toggleMobileSubMenuList('plan_2')" :class="{'open': subMenu.includes('plan_2')}">
                监控系统解决方案
                <i class="mb-menu-open-icon el-icon-arrow-right"></i>
              </div>
              <div class="mb-menu-sub-item-two" :class="{'open': subMenu.includes('plan_2')}">
                <div>方案简介</div>
                <div>成功案例</div>
              </div>
            </div>
            <div v-if="index === 2" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one">APP简介</div>
              <div class="mb-menu-sub-item-one">成功案例</div>
              <div class="mb-menu-sub-item-one" @click="toggleMobileSubMenuList('oem')" :class="{'open': subMenu.includes('oem')}">
                功能OEM
                <i class="mb-menu-open-icon el-icon-arrow-right"></i>
              </div>
              <div class="mb-menu-sub-item-two" :class="{'open': subMenu.includes('oem')}">
                <div>基于KDView</div>
                <div>量身定制</div>
              </div>
            </div>
            <div v-if="index === 3" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one">技术支持</div>
              <div class="mb-menu-sub-item-one">web在线观看</div>
              <div class="mb-menu-sub-item-one" @click="toggleMobileSubMenuList('download')" :class="{'open': subMenu.includes('download')}">
                下载
                <i class="mb-menu-open-icon el-icon-arrow-right"></i>
              </div>
              <div class="mb-menu-sub-item-two" :class="{'open': subMenu.includes('download')}">
                <div>客户端下载</div>
                <div>SDK开发</div>
                <div>其它下载</div>
              </div>
            </div>
            <div v-if="index === 4" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#company">公司介绍</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#team">团队简介</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#contact">联系我们</a>
              </div>
            </div>
            <div v-if="index === 5" class="mb-menu-sub-item" >
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#company">公司介绍</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#team">团队简介</a>
              </div>
              <div class="mb-menu-sub-item-one">
                <a href="/introduce#contact">联系我们</a>
              </div>
            </div>
          </div> -->
        </div>
        <div @click="goLogin" class="md-login"><div>登录开放平台</div></div>
        <div class="md-login-shadow"></div>
      </div>
    </div>
    <div  v-show="mobileType && openMenu" :class="{'openmenu': openShadow}" @touchmove="touchmove"  class="back-shadow"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: -1,
      openMenu: false,
      mobileType : false,
      openShadow: false,
      showMenu: [],
      subMenu: [],
      main_menu : [
        {
          name: "云平台",
          href: "/cloud",
        },{
          name: "硬件接入",
          href: "/hardware",
        },{
          name: "APP开发",
          href: "/app",
        },{
          name: "服务部署",
          href: "/service",
        },{
          name: "方案&案例",
          href: "/case",
        },{
          name: "关于我们",
          href: "/introduce",
        },
      ],
    };
          
  },
  watch : {
    openMenu (to){
      setTimeout(() => {
        this.openShadow = to
      },10)
    }
  },
  mounted() {
    this.checkWindow();
    window.addEventListener('resize',this.checkWindow);
    setTimeout(this.checkWindow, 100)
  },
  methods : {
    goLogin(){
      window.location.href = "http://open.kdzn.top"
    },
    touchmove(e){
      if(this.openMenu){
        e.preventDefault();
      }
    },
    toggleMobileMenuList(index, isOpen){
      if(isOpen){
        this.showMenu = this.showMenu.filter(item => item !=index)
      } else {
        this.showMenu.push(index)
      }
    },
    toggleMobileSubMenuList(index){
      if(this.subMenu.includes(index)){
        this.subMenu = this.subMenu.filter(item => item !=index)
      } else {
        this.subMenu.push(index)
      }
    },
    toggleMobileMenu(){
      this.openMenu = !this.openMenu;
    },
    hold(index){
      this.selected = index
    },
    out(){
      this.selected = -1
    },
    checkWindow() {
      this.mobileType = window.outerWidth <= 900
      if(!this.mobileType){
        this.openMenu = false;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
  .mb-menu a{
    display:block;
  }
  .menu-item a{
    line-height: 50px;
    display: inline-block;
  }
  .logo img {
    position: absolute;
    z-index: 1000;
    top: 0;
    width: 250px;
    height: 75px;
  }
  a{
    color: unset !important;
    text-decoration: unset !important;
  }
  .back-shadow{
    // <!-- display: none; -->
    background-color: rgba(255,255,255,.0);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 1;
    transition: background-color .5s;
  }
  .openmenu.back-shadow{
    display:block;
    background-color: rgba(19,20,21,.6);
  }
  body {
    --diy-color: #0261ff;
  }
  .md-login-shadow{
    width: 100%;
    height: 100px;
  }
  .hide .md-login{
    right: -100vw;
  }
  .md-login{
    color: #0261ff;
    font-weight: 700;
    font-size : 16px;
    height: 27px;
    padding-top: 16px;
    padding-bottom: 46px;
    border-top:1px rgb(231,233,237) solid;
    text-align: center;
    max-width:430px;
    width: 100%;
    position:fixed;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    transition: right .5s;
  }
  .mb-menu-sub-item-two{
    padding-left: 40px;
    overflow: hidden;
  }
  .mb-menu-sub-item-one{
    padding-left: 20px;
  }
  .open .open.mb-menu-sub-item-two>div,
  .open .mb-menu-sub-item .mb-menu-sub-item-one{
    max-height: 100px;
  }
  .mb-menu-sub-item-two>div,
  .mb-menu-sub-item .mb-menu-sub-item-one{
    max-height: 0;
    transition : display .5s, max-height .5s;
  }
  .mb-menu-sub-item-one,
  .mb-menu-sub-item{
    overflow: hidden;
  }
  .mb-menu-open-icon{
    font-size: 16px;
    float: right;
    font-weight:600;
    margin-top: 13px;
    color: #aaaaaa;
  }
  .mb-top-box{
    width: 100%;
    height: 53px;
  }
  .open.mb-menu-item .mb-menu-sub-item-one .mb-menu-open-icon{
    transform:rotate(0deg);
    color: #aaaaaa;
  }
  .open.mb-menu-item .open.mb-menu-sub-item-one .mb-menu-open-icon,
  .open.mb-menu-item .mb-menu-open-icon{
    color: #000000;
    transform:rotate(90deg);
  }
  .mb-menu-item {
    line-height: 48px;
    font-size: 16px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .mb-menu-open-icon {
    transition : color .5s, transform .5s;
  }
  .mb-menu.hide{
    right: -100vw;
  }
  .mb-menu{
    overflow: auto;
    top:0;
    right:0;
    max-width: 430px;
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: #ffffff;
    z-index: 2;
    transition: right .5s;
  }
  .mb-menu-icon i{
    position: absolute;
    right: 30px;
    z-index: 4;
  }
  .mb-menu-list{
    background-color: #ffffff;
  }
  .mb-menu-icon{

    float: right;
    margin-top: 12px;
    font-size: 24px;
    color: #999999;
  }
  .mb-menu-icon.openmenu{
    color: #0261ff;
  }
  .mb-header{
    background-color: #fff;
    padding: 0 10px;
    margin-bottom: 10px;
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    top: 0;
    z-index: 2;
    height: 53px;

  }

  .header {
    background-color: #fff;
    padding: 0 24px;
    margin-bottom: 0px;
    height: 100px;
    box-shadow: 0 0 50px rgb(0 0 0 / 5%);
  }
  .header-sub{
    display: inline-block;
  }
  .logo-item{
    height: 26px;
    margin-top: 13px;
    margin-left: 4px;
  }
  .right-sub{
    float: right;
    margin-top: 17px;
  }
  .header-item{
    margin-left: 20px;
    font-size: 12px;
    display: inline-block;
    cursor: pointer;
    line-height: 24px;
    font-family: PingFang-SC-Regular, "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  }
  .left-icon{
    width:70px;
    font-size: 18px;
    font-weight: 600;
    color: #777;
    font-style: oblique;
    letter-spacing: 2px;
    line-height: 50px;
    display: inline-block;
  }
  .menu{
    z-index: 10;
    position: absolute;
    background: #fff;
    left: 200px;
    right: 24px;
    top: 43px;
  }
  .menu-nav{
    padding: 0 16px;
    line-height: 57px;
    text-align: center;
    display: inline-block;
  }
  .menu-item{
    letter-spacing: 1px;
    position: relative;
    padding: 0 16px;
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    font-family: PingFang-SC-Regular,PingFang SC,Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,Heiti SC,WenQuanYi Micro Hei,sans-serif;
  }
  .simple-menu-item{
    letter-spacing: 1px;
    padding: 0 16px;
    display: inline-block;
    font-size: 14px;
    line-height: 0;
    overflow:hidden;
  }
  .menu-item:hover, header-item:hover {
    color: #0261ff;
    cursor: pointer;
  }
  .open-menu {
    position: absolute;
    bottom: 2px;
    left: 0;
    right: 0;
    font-size: 12px;
    font-weight: 600;
    display: none;
  }
  .menu-item:hover .open-menu{
    display: block;
  }
  .right-icon {
    float: right;
  }
  .go-login{
    height: 28px;
    min-width: 72px;
    padding: 0 12px;
    background-color: #0261ff;
    border: none;
    border-radius: 24px;
    line-height: 28px;
    color: #fff;
    font-size:14px;
    text-align:center;
    margin-top: 15px;
    cursor: pointer;
  }
  .go-login:hover{
    background-color:blue;
  }
  .menu-list{
    height: 0;
    overflow: hidden;
  }
  .menu-list-box{
    display:inline-block;
    width: fit-content;
    position: absolute;
    z-index:1;
    line-height: 20px;
    text-align: left;
    color: #000;
  }
  .menu-list-box-real{
    display: flex;
    position: relative;
    background: #fff;
    padding: 14px 12px 6px;
    border-bottom-left-radius:  8px;
    border-bottom-right-radius: 8px;
    /*width: 650px;*/
    box-shadow: 2px 6px 6px 3px #00000040;
  }
  .title-item{
    font-size: 16px;
    color: #0261ff;
    margin: 0 0 16px;
  }
  .value-item{
    font-size: 14px;
    margin: 0 0 16px;
    cursor: pointer;
  }
  .value-item:hover{
    color: #0261ff;
  }
  .info-item{
    font-size: 14px;
  }
  .menu-list-box-item{
    display: inline-block;
    max-width: 300px;
  }
  .menu-list-box-item.left-item{
    float: left;
    max-width: 350px;
    padding-right: 40px;
    margin-right: 8px;
    border-right: 1px solid #ccc;
  }

  .hidden{display:none;}
</style>
